import { useMutation } from "@tanstack/react-query";
import { usePymbleApi } from "./usePymbleApi";

const API_END_POINT = "/group/admin/notify/";

export interface GroupNotification {
  Method: "push" | "email";
  Title: string;
  Body: string;
  Groups: string[];
  SendAt?: string;
  From?: string;
}

/**
 * Hook to notify groups
 */
export function useGroupNotify() {
  const { callApi } = usePymbleApi();

  const mutation = useMutation({
    mutationFn: async (notification: GroupNotification) => {
      const request_type = notification.Method == "push" ? "send" : "email";
      const request: Record<string, unknown> = {
        Title: notification.Title,
        Body: notification.Body,
        Groups: notification.Groups,
      };
      if (request_type == "email" && notification.From == "ce") {
        request["From"] = "ce";
      }
      return await callApi(
        "POST",
        API_END_POINT + "?request_type=" + request_type,
        { data: request }
      );
    },
  });

  const sendToGroups = async (notification: GroupNotification) => {
    return mutation.mutateAsync(notification);
  };

  return {
    sendToGroups,
    notificationSending: mutation.isPending,
  };
}
